import React, { Fragment } from 'react';
import type { WRelatedLinkView } from '@zola/svc-web-api-ts-client';
import { LinkV2 } from '../LinkV2';
import { Section, Container, Title, List, ListItem } from './SEORelatedLinks.styles';

interface SEORelatedLinksProps {
  title: string;
  relatedLinks: WRelatedLinkView[];
}

const getLinks = (relatedLinks: WRelatedLinkView[]) => (
  <Fragment>
    {relatedLinks.map(({ title, url_path: urlPath }) => (
      <ListItem key={urlPath}>
        <LinkV2 href={urlPath} variant="primary" noUnderline>
          {title}
        </LinkV2>
      </ListItem>
    ))}
  </Fragment>
);

const SEORelatedLinks = ({ title, relatedLinks }: SEORelatedLinksProps): JSX.Element => (
  <Section>
    <Container className="container">
      <Title>{title}</Title>
      <List>{getLinks(relatedLinks)}</List>
    </Container>
  </Section>
);

export default SEORelatedLinks;
